export const gotoParamMiddleware = (goto) => (req, action, next) => {
  req.url.searchParams.append('goto', goto);
  next();
};

export const forceAuthMiddleware = () => (req, action, next) => {
  req.url.searchParams.append('ForceAuth', 'true');
  next();
};

export const brandMiddleware = (brand) => (req, action, next) => {
  try {
    if (typeof brand === 'string') {
      req.url.searchParams.append('brand', brand);
    }
  } catch {
    // Do nothing - fall back to not sending brand and proceed as normal
  } finally {
    next();
  }
};
